var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "20px",
    viewBox: "0 0 57 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Buttocks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-18",
    transform: "translate(-60.000000, -182.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,182 L115.335158,182 L116.676157,193.718408 C116.555348,194.141483 113.988029,195.768592 108.9742,198.599738 C101.434555,203.835872 92.5689056,201.015999 88.4509987,197.846677 C85.2494245,200.322983 79.1891162,203.632095 68.2864337,198.875691 C66.0908783,197.571327 63.4748113,195.602539 60.4382325,192.969327 C60.7084137,190.523952 61.2290029,186.86751 62,182 Z",
    id: "Buttocks"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtocks);
export default __webpack_public_path__ + "static/media/Buttocks.f15cd387f2ddedbf53fe993bbf126e7c.svg";
export { ForwardRef as ReactComponent };